import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payments--checkout"
export default class extends Controller {
  static targets = ["button"];
  static values = {
    keyId: String,
    amount: Number,
    orderId: String,
    successCallback: String,
  };

  instantiate() {
    if (window.Razorpay) {
      this.Razorpay = window.Razorpay;
      this.razorpay = new this.Razorpay(this.options);
    } else {
      console.error("Razorpay not instantiated.");
    }
  }

  pay() {
    this.buttonTarget.disabled = true;
    this.razorpay.open();
  }

  get options() {
    return {
      key: this.keyIdValue,
      amount: this.amountValue,
      currency: "INR",
      name: "TinyOval",
      order_id: this.orderIdValue,
      callback_url: this.successCallbackValue,
    };
  }
}
